/* e88f7ec2825bfbaa6d9ff49ac3c28842dea6d08d
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AvailablePaymentMethodsQueryVariables = Types.Exact<{
  locale: Types.Locale;
}>;


export type AvailablePaymentMethodsQuery = { __typename?: 'Query', availablePaymentMethods?: { __typename?: 'AvailablePaymentMethods', merchantId?: string | null, posIdRest?: number | null, payByLinks?: Array<{ __typename?: 'PayuPayByLink', name?: string | null, value?: Types.PaymentChannel | null, brandImageUrl?: string | null, status?: Types.PayUMethodStatus | null } | null> | null, cardTokens?: Array<{ __typename?: 'PayuCardToken', brandImageUrl?: string | null, cardScheme?: string | null, cardExpirationYear?: string | null, cardExpirationMonth?: string | null, cardNumberMasked?: string | null, value?: string | null, preferred?: boolean | null, status?: Types.PayUMethodStatus | null } | null> | null, status?: { __typename?: 'PayUResponseStatus', statusCode?: Types.PayUResponseStatusCode | null, statusDesc?: string | null } | null } | null };


export const AvailablePaymentMethodsDocument = gql`
    query AvailablePaymentMethods($locale: Locale!) {
  availablePaymentMethods(locale: $locale) {
    payByLinks {
      name
      value
      brandImageUrl
      status
    }
    cardTokens {
      brandImageUrl
      cardScheme
      cardExpirationYear
      cardExpirationMonth
      cardNumberMasked
      value
      preferred
      status
    }
    merchantId
    posIdRest
    status {
      statusCode
      statusDesc
    }
  }
}
    `;

/**
 * __useAvailablePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentMethodsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useAvailablePaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
      }
export function useAvailablePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
        }
export type AvailablePaymentMethodsQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsQuery>;
export type AvailablePaymentMethodsLazyQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsLazyQuery>;
export type AvailablePaymentMethodsQueryResult = Apollo.QueryResult<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>;